import { CssBaseline, ThemeProvider } from "@mui/material";
import React from "react";

import AppShell from "components/AppShell";
import useAppTheme from "hooks/useAppTheme";
import { ToastContainer } from "react-toastify";
import "./App.css";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const App = () => {
  const theme = useAppTheme();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AppShell />
      </LocalizationProvider>
      <ToastContainer enableMultiContainer />
    </ThemeProvider>
  );
};

export default App;
